import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';

import { IBreadcrumb } from '../../models';
import { BreadcrumbService } from '../../services';

import { BreadcrumbItemComponent } from './breadcrumb-item.component';


@Component({
	selector: 'layout-breadcrumb',
	templateUrl: './breadcrumb.component.html',
	imports: [BreadcrumbItemComponent, RouterLink, AsyncPipe]
})
export class BreadcrumbComponent {
	public breadcrumbs: Observable<IBreadcrumb[]> = this.breadcrumbService.breadcrumbs$;

	constructor(private breadcrumbService: BreadcrumbService) { }
}
